import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { API_PATHS } from "../../utils/apiPaths";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import moment from "moment";
import AvatarGroup from "../../components/AvatarGroup";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import "moment/locale/fr";
moment.locale("fr");
const ViewTaskDetails = () => {
  const { id } = useParams();
  const [task, setTask] = useState(null);
  const getStatusTagColor = (status) => {
    switch (status) {
      case "encours":
        return "text-cyan-500 bg-cyan-50 border border-cyan-500/10";
      case "terminé":
        return "text-lime-500 bg-lime-50 border border-lime-500/20";
      default:
        return "text-violet-500 bg-violet-50 border border-violet-500/10";
    }
  };
  //get Task details by id
  const getTaskDetailByID = async (id) => {
    try {
      const response = await axiosInstance.get(API_PATHS.TASKS.GET_BY_ID(id));
      console.log(response.data);
      if (response.data) {
        const taskInfo = response.data;
        setTask(taskInfo);
      }
    } catch (error) {
      console.error("Erreur de recuperation des users:", error);
    }
  };
  //handle todo checklist
  const updateTodoChecklist = async (index) => {
    const todoCheckList = [...task.todoCheckList];
    const taskId = id;
    if (todoCheckList && todoCheckList[index]) {
      todoCheckList[index].completed = !todoCheckList[index].completed;
    }
    try {
      const response = await axiosInstance.put(
        API_PATHS.TASKS.UPDATE_TODO_CHECKLIST(taskId),
        { todoCheckList }
      );
      if (response.status === 200) {
        setTask(response.data?.task || task);
      } else {
        todoCheckList[index].completed = !todoCheckList[index].completed;
      }
    } catch (error) {
      todoCheckList[index].completed = !todoCheckList[index].completed;
    }
  };
  useEffect(() => {
    if (id) {
      getTaskDetailByID(id);
    }
    return () => {};
  }, [id]);
  //handle attachment link lick
  const handleLinkClick = (link) => {
    const formattedLink = link.startsWith("http") ? link : `https://${link}`;
    window.open(formattedLink, "_blank", "noopener,noreferrer");
  };
  return (
    <DashboardLayout activeMenu={"My Tasks"}>
      <div className="mt-5">
        {!task ? (
          <p className="text-sm text-gray-500 mt-4">
            Chargement de la tâche...
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-4 mt-4">
            <div className="form-card col-span-3">
              <div className="flex items-center justify-between">
                <h2 className="text-sm md:text-xl font-medium">
                  {task?.title}
                </h2>
                <div
                  className={`text-[11px] md:text-[13px] font-medium ${getStatusTagColor(
                    task?.status
                  )} px-4 py-0.5 rounded`}
                >
                  {task?.status}
                </div>
              </div>

              <div className="grid grid-cols-12 gap-4 mt-4">
                <div className="col-span-6 md:col-span-4">
                  <InfoBox label="Description" value={task?.description} />
                </div>
                <div className="col-span-6 md:col-span-4">
                  <InfoBox label="Priorité" value={task?.priority} />
                </div>
                <div className="col-span-6 md:col-span-4">
                  <InfoBox
                    label="Date d'échéance"
                    value={
                      task?.dueDate
                        ? moment(task?.dueDate).format("Do MMM YYYY")
                        : "N/A"
                    }
                  />
                </div>
                <div className="col-span-6 md:col-span-4">
                  <label className="text-xs font-medium text-slate-500">
                    Membres assignés
                  </label>
                  <AvatarGroup
                    avatars={
                      task?.assignedTo?.map((item) => item?.profileImageUrl) ||
                      []
                    }
                    maxVisible={5}
                  />
                </div>
              </div>

              <div className="mt-2">
                <label className="text-xs font-medium text-slate-500">
                  Liste de contrôle
                </label>
                {task?.todoCheckList?.map((item, index) => (
                  <TodoCheckList
                    key={`todo-${index}`}
                    text={item.text}
                    isChecked={item?.completed}
                    onChange={() => updateTodoChecklist(index)}
                  />
                ))}
              </div>

              {task?.attachments?.length > 0 && (
                <div className="mt-2">
                  <label className="text-xs font-medium text-slate-500">
                    Pièces jointes
                  </label>
                  {task?.attachments?.map((link, index) => (
                    <Attachment
                      key={`link_${index}`}
                      link={link}
                      index={index}
                      onClick={() => handleLinkClick(link)}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};
export default ViewTaskDetails;

const InfoBox = ({ label, value }) => {
  return (
    <>
      <label className="text-xs font-medium text-slate-500">{label}</label>
      <p className="text-[12px] md:text-[13px] font-medium text-gray-700 mt-0.5">
        {value}
      </p>
    </>
  );
};

const TodoCheckList = ({ text, isChecked, onChange }) => {
  return (
    <div className="flex items-center gap-3 mt-2">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        className="w-4 h-4 cursor-pointer w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded-sm outline-none"
      />
      <p className="text-[13px] text-gray-800">{text}</p>
    </div>
  );
};

const Attachment = ({ link, index, onClick }) => {
  return (
    <div
      className="flex items-center justify-between bg-gray-50 border border-gray-100 px-3 py-2 rounded-md gap-2 mt-2 mb-3 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex-1 flex items-center gap-3 border">
        <span className="text-gray-500 font-mono text-sm bg-gray-200 px-2 py-1 rounded-md">
          {index < 9 ? `0${index + 1}` : index + 1}
        </span>
        <p className="text-xs text-black">{link}</p>
      </div>
      <LuSquareArrowOutUpRight className="text-gray-500" />
    </div>
  );
};
